import { Statustext } from "../enums/status";

export class RedliningAcknowledgeModel{
  ID:number;
  RedliningID:number;
  UserID:number;
  Status:Statustext
}
